//import React, { useState } from 'react';
import Navigation from '../Navigation/Navigation.js';

import './Header.scss';

const Header = () => {
  return (
    <header className="header">
      <Navigation />
    </header>
  )
};

export default  Header;